const ProjectText = ({tag}) => {

    switch (tag) {
    case 'Storybook':
        return (
            "I'm at the stage of being totally intreguied with Storybook, and would love to work on a large project in which its use is essential."
        );


    case 'Tailwind':
        return (
            "I'm a huge fan of Tailwind. It allows me to build almost any layout or design quickly, and makes styling websites enjoyable. Incredibly powerful."
        );


    case 'React':
        return (
            'I just adore the using React. The component-based structure is analogous to the way I think when building sites. A real pleasure. Just spinning up new React project excites me.'
        );


    case 'Gatsby':
        return (
            "The cherry on top of React's cake. Gatsby continues to amaze me on a daily basis, whether it's the huge ecosystem, or some cool new functionality I didn't know existed. Brilliant DX."
        );

    case 'Svelte':
        return (
            "My go-to 'library' before I learned React. I'm fascinated by how Svelte is a compiler rather than a library, and love how little code is required. I'd love to use it, and Sapper, more."
        );

    case 'Vue':
        return (
            'The first Javascript framework I became familiar with. Fast, lightweight, easy-to-learn and offering a great developer experience.'
        );

    case 'GraphQL':
        return (
            "I love how easy GraphQL makes it to retrieve the exact data I need, whether it's from a headless cms or just a Markdown file stored locally."
        );

    case 'Apollo':
        return (
            'Another one of the backend technologies I would really like to get a handle of given that I work with GraphQL a lot.'
        );

    case 'Bootstrap':
        return (
            "Though personally I'm not a fan of 'rigid' css frameworks such as Bootstrap, it does allow me to scaffold a layout or design elements when conceptualising a website."
        );

    case 'Firebase':
        return (
            "Firebase's suite of services intrigue me greatly, and it's a skillset I wish to concentrate on improving, especially Authentication and the effective use of Cloud Functions."
        );

    case 'MongoDB':
        return (
            "A database that stores its data as JSON documents yet gives you the power of relational database queries. What's not to like? I do need to learn more of this."
        );

    case 'Electron':
        return (
            "Electron is a fantastic tool when combined with a frontend-framework such as React, Svelte or Vue. I like it so much I'm trying to fit in a side prject just so I can use it."
        );

    case 'Markdown':
        return (
            "The odd one out of all the techs listed. Not a skill in itself, but I think the ability to use other technologies to enable you to use Markdown is quiet powerful. This site's content is stored in Markdown."
        );

    default:
        return (
            'Welcome to my portfolio. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.'
        )
    }
}

export default ProjectText